// 实人认证模块

import realpplAuth from './realpplAuth'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    realpplAuth,
  }
}
